export default function getCurrentYear() {
  return new Date().getFullYear();
}
